import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import DatesView from 'views/dates'; // Importing DatesView component
import AllTActions from 'views/alltactions'; // Importing AllTActions component
import { login } from 'config/config'; // Importing login configuration

/**
 * TransactionsView class extends JetView to create a view for transactions.
 */
export default class TransactionsView extends JetView {
    /**
     * Configures the layout of the TransactionsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right side layout containing PersonsView and DatesView
        const right = {
            type: 'wide',
            rows: [PersonsView, DatesView],
        };

        // Left side layout with toolbar and actions
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for transaction options
                    css: theme, // Applying the current theme
                    elements: [
                        { view: 'label', label: _('Transactions'), width: 150 }, // Label for the toolbar
                        { minWidth: 4 },
                        {
                            view: 'segmented', // Segmented control for filtering transactions
                            minWidth: 333,
                            options: [
                                { id: 'all', value: _('All') }, // Option for all transactions
                                { id: '0', value: _('Payments') }, // Option for payments
                                { id: '1', value: _('Incoming') }, // Option for incoming transactions
                            ],
                            on: {
                                // Event handler for changing the filter
                                onChange: (newv) =>
                                    this.app.callEvent('tactions:filter', [
                                        newv, // Pass the new value to the filter event
                                    ]),
                            },
                        },
                        { width: 6 },
                    ],
                },
                AllTActions, // Including AllTActions component in the layout
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: 'wide',
            responsive: true, // Enable responsive layout
            cols: [left, right], // Define the columns layout
        };
    }
}

// FILE DOCUMENTED
